import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import EstateResource from '/@/modules/estate/resources/EstateResource';
import CurrentEstateService from '/@/modules/estate/services/CurrentEstateService';

export class EstateChangeEstateService extends BaseService {
  constructor() {
    super();
    this.resource = EstateResource;
  }

  /**
   * @return {Promise<Estate[]>}
   */
  getEstates() {
    return this.resource.getAllAccessibleEstates();
  }

  /**
   * @return {Promise<Estate[]>}
   */
  getSelectionEstates(params = {}) {
    return this.resource.getSelectionEstates(params);
  }

  /**
   * @param {Estate} estate
   * @return {Promise<*>}
   */
  async changeEstate(estate) {
    await CurrentEstateService.setCurrentEstate(estate.id);
  }
}

export default new EstateChangeEstateService();
